import {DB_SCHEMAS} from '../db/schemaExports';
import {initContract} from '@ts-rest/core';
import {z} from 'zod';

const c = initContract();

export const chatCompletionContract = c.router(
  {
    completion: {
      method: 'POST',
      path: '/:id/completion',
      pathParams: DB_SCHEMAS.selectChatConversation.pick({id: true}),
      body: z.object({
        prompt: z.string().max(10000).describe('The prompt to complete the chat conversation'),
        kbIds: z.array(z.string().uuid()).describe('The IDs of the knowledge bases to use for the completion'),
        assistantId: z.string().uuid().optional().describe('The ID of the assistant to use for the completion'),
        attachmentIds: z
          .array(z.string().uuid())
          .max(3)
          .default([])
          .describe('IDs of pre-uploaded chat attachments to bind to the user message')
      }),
      responses: {
        200: c.noBody()
      },
      summary: 'Get a completion for a chat conversation',
      description: 'Get a completion for a chat conversation'
    }
  },
  {
    pathPrefix: '/chat-conversations'
  }
);
